module.exports = __webpack_public_path__ + "static/media/noticeBg.e0c729ab.svg";